import { IImage } from 'types/product';

export const getItemCondition = (): string => 'https://schema.org/NewCondition';

export const applyURIProtocol = ({ zoom }: IImage): string => {
  if (zoom) {
    return zoom.startsWith('http') ? zoom : `https:${zoom}`;
  }
  return null;
};

export const getToday = (): string => {
  const now = new Date().toISOString();
  return now.substring(0, 10);
};

export const getAggregateRating = (rate: Record<string, any>): Record<string, any> => {
  if (!rate) {
    return null;
  }

  const { average = 0, count = 0, best } = rate;
  if (count === 0) {
    return null;
  }

  return {
    ratingValue: average.toString(),
    reviewCount: count.toString(),
    bestRating: best?.toString(),
  };
};

export const getAvailability = ({
  isOutOfStock,
  isOffline,
}: {
  isOutOfStock: boolean;
  isOffline: boolean;
}): string => {
  if (isOutOfStock) {
    return 'https://schema.org/OutOfStock';
  }
  if (isOffline) {
    return 'https://schema.org/Discontinued';
  }

  return 'https://schema.org/InStock';
};
